export default "__VITE_ASSET__3ad79f1c__"